<template>
    <main class="dashboard">
        <Header />

        <div class="main-section" style="min-height: 100vh; background: rgb(248, 249, 253);">
            <div class="container">
                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`" @click="() => back()"
                    class="volverButton">
                    <span style="font-size: 20px;"><img :src="arrow" class="arrow" /> Volver</span>
                </SimpleButton>
                <h3 class="title is-2 has-text-centered pt-3">
                    {{ basicData.company_name }}
                </h3>
                <div class="is-relative plainCard has-text-centered is-clipped has-background-white">
                    <p class="has-text-primary-dark is-uppercase has-text-weight-semibold"
                        style="text-overflow:ellipsis; white-space: nowrap; overflow: hidden"
                        :title="basicData.nameContact">
                        Empresa {{ basicData.company_type }}
                    </p>
                </div>
                <div class="columns m-5 has-text-centered">
                    <div class="column is-6 plainCard has-background-white">
                        <p class="title is-5">Datos Básicos</p>
                        <div class="columns">
                            <div class="column is-4"> <strong>Fecha de inscripción:</strong></div>
                            <div class="column is-8" v-if="!!user.account_link">{{
                    moment(user.account_link.created_at).format('DD-MM-YYYY') }}</div>
                        </div>
                        <div class="columns">
                            <div class="column is-4"> <strong>Contacto:</strong></div>
                            <div class="column is-8">{{ basicData.bigger_email }}</div>
                        </div>
                        <div class="columns">
                            <div class="column is-4"> <strong>Linea de negocio:</strong></div>
                            <div class="column is-8"></div>
                        </div>
                        <div class="columns">
                            <div class="column is-4"><strong>Estado:</strong></div>
                            <div class="column is-8"></div>
                        </div>
                        <div class="columns">
                            <div class="column is-4"><strong>Libro General:</strong></div>
                            <div class="column is-8 buttons are-small">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openUpdateModalIdSheet()">
                                    Actualizar
                                </SimpleButton>
                                <SimpleButton class="is-secondary"
                                    :buttonStyle="`linear-gradient(225deg, #d0d0ff, #f0f0ff)`"
                                    v-if="basicData.general_book_id_sheet" @click="() => goToSheet()">
                                    Ir
                                </SimpleButton>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-4">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openUpdateOperationsByUserModal()">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Operaciones del usuario</span></td>
                                            <td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                            </div>
                        </div>
                    </div>
                    <div class="column is-one-quarter plainCard has-background-white">
                        <p class="title is-5">Contacto</p>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Sugerencia minuta</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Enviar correo contacto</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Enviar correo contador</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Agregar contacto</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openEnviarCorreoTaxDocuments('sii')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Enviar correo documentos SII</span></td>
                                            <td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openEnviarCorreoTaxDocuments('banks')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Enviar correo documentos Bancos</span></td>
                                            <td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                            </div>
                        </div>
                    </div>
                    <div class="column is-one-quarter plainCard has-background-white">
                        <p class="title is-5">Reporte</p>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Ver reporte</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Configurar reporte</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Configurar paneles</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openModalReloadReport('sii')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar SII desde fintoc</span></td>
                                            <td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openModalReloadReport('bank')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar movimientos desde fintoc</span></td>
                                            <td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    :disabled="loadingReloadDrive" @click="() => sendObligationsToDrive('sii')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar drive para obligaciones</span></td>
                                            <td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    :disabled="loadingReloadDrive" @click="() => sendObligationsToDrive('bank')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar drive para movimientos</span></td>
                                            <td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="title is-3 has-text-centered">Entrada de datos</p>
                <table class="table is-striped is-hoverable is-fullwidth has-text-centered">
                    <thead>
                        <tr>
                            <th>Entrada</th>
                            <th>Última Actualización</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="file in fileData " v-bind:key="file.fileType">
                            <td class="content is-vcentered">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #f5f5f9, #fafaff)`"
                                    @click="openFileModal(file.file_id, file.desc)">{{ file.desc }}</SimpleButton>
                            </td>
                            <td>
                                {{ moment(file.latest_date).format('DD-MM-YYYY') }}
                                <p v-if="!isLessThanMonth(file.latest_date)">
                                    <strong>(Atraso)</strong>
                                </p>
                                <p class="" v-if="!file.uploaded && isLessThanMonth(file.latest_date)">
                                    <strong>(Problema en el archivo)</strong>
                                </p>
                            </td>
                            <td class="content is-vcentered">
                                <!-- {{ file.uploaded }} -->
                                <p>
                                    <!-- a v-if="!file.uploaded || !isLessThanMonth(file.latest_date)"
                                        class="mr-3"><u>Solicitar</u></a -->
                                    <SimpleButton :buttonStyle="`linear-gradient(225deg, #faf5f5, #fff0f0)`"
                                        @click="openSolicitarArchivo(file.file_id)">Solicitar</SimpleButton>
                                    <SimpleButton :buttonStyle="`linear-gradient(225deg, #f5faf5, #f0fff0)`"
                                        @click="openUploadFileUsers(file.file_id)">Subir</SimpleButton>
                                    <a v-if="false"><u>Soporte </u></a>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </main>
</template>

<script>
import { getDetalleCompania, getUsersByCompany } from "@/api/carteraAnalista";
import { downloadMovementsToSheet, downloadObligationsToSheet } from "@/api/downloadObligationsToSheet";
import { getFilesUsersByCompany } from "@/api/uploadFiles";
import Header from "@/components/dashboard/Header";
import ChangeOperationsByUsers from "@/components/modals/ChangeOperationsByUsers";
import CompanyUploads from "@/components/modals/CompanyUploads";
import IdSheetUpdate from "@/components/modals/IdSheetUpdate";
import ReloadFintocByCompany from "@/components/modals/ReloadFintocByCompany";
import SimpleButton from "@/components/modals/SimpleButton";
import UploadFileAsUserModal from "@/components/modals/UploadFileAsUserModal";
import { consoleHandlerError, notificate } from "@/utils/message";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "CompanyInfo",
    components: {
        Header,
        SimpleButton,
    },
    created() {
        const companyId = this.$route.query.companyId;
        this.companyRut = this.$route.query.companyRut;
        if (!companyId) {
            this.$router.push({ name: 'panel-analista' });
        } else {
            this.fetchCompanyData(companyId);
        }
        getFilesUsersByCompany(companyId).then(({ data }) => {
            this.allFilesByUser = data
        })
        getUsersByCompany(companyId).then(({ data }) => {
            this.allUsers = data
        })
    },
    data() {
        return {
            publicPath: "http://" + window.location.hostname,
            modalDefault: {
                parent: this,
                hasModalCard: true,
                width: '99%',
                height: 1000,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
                "full-screen": true,
            },
            modalDefaultUpdateSheet: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            basicData: {},
            fileData: [],
            bigger_email: '',
            allFilesByUser: [],
            allUsers: [],
            companyRut: '',
            loadingReloadDrive: false,
        };
    },
    computed: {
        ...mapState("userAuth", ["user"]),
        sii_logo: function () { return `${this.publicPath}/Logo_de_Servicio_de_Impuestos_Internos.png` },
        bank_logo: function () { return `${this.publicPath}/bank_logo.png` },
        arrow() { return `${this.publicPath}/arrow-back-128.png`; }
    },
    methods: {
        back() {
            window.location.href = "#/panel-analista";
        },
        async fetchCompanyData(id) {
            try {
                const resp = await getDetalleCompania(id);
                this.basicData = resp.data;
                this.basicData.companyId = parseInt(id);
                this.fileData = Object.values(this.basicData['file_data']);
                this.fileData.sort((a, b) => a.order - b.order);
            } catch (error) {
                console.error('Error fetching company details:', error);
            }
        },
        onModalClose() {
            this.fetchCompanyData(this.basicData.companyId);
        },
        moment(date) {
            return moment(date);
        },
        isLessThanMonth(date) {
            let today = moment()
            let monthBefore = today.subtract(1, 'months')
            let compareDate = moment(date)
            return monthBefore <= compareDate
        },
        openFileModal(id, file_desc) {
            this.basicData['file_id'] = id;
            this.basicData['file_desc'] = file_desc;
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: CompanyUploads,
                props: {
                    basicData: this.basicData,
                },
            });
        },
        openUpdateModalIdSheet() {
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: IdSheetUpdate,
                props: {
                    companyId: this.basicData.companyId,
                    general_book_id_sheet: this.basicData.general_book_id_sheet
                },
                events: {
                    updateIdSheet: (newId) => {
                        this.basicData.general_book_id_sheet = newId
                    },
                },
            });
        },
        openUploadFileUsers(fileId) {
            let allUsersByFileId = this.allFilesByUser.filter(fileUser => {
                let fileFinded = fileUser.files.filter(file => file.id == fileId)
                return fileFinded.length > 0
            })
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ['escape', 'button', 'outside'],
                onCancel: () => this.onModalClose(),
                props: {
                    fileId,
                    idCompany: this.basicData.companyId,
                    hideHistoricBtn: false,
                    selectedFilesByUser: allUsersByFileId,
                    sendMail: false,
                },
                events: {
                    close: () => {
                        this.onModalClose();
                    }
                },
            });
        },
        openEnviarCorreoTaxDocuments(which) {
            let allUsersByFileId = this.allUsers;
            if (allUsersByFileId == null || allUsersByFileId.length == 0) {
                alert('Error, no se encontraron usuarios para enviar un correo');
                return;
            }
            const message = which == 'sii' ? 'Enviar el correo con las obligaciones a' :
                'Enviar el correo con los movimientos bancarios a';
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ['escape', 'button', 'outside'],
                onCancel: () => this.onModalClose(),
                props: {
                    idCompany: this.basicData.companyId,
                    hideHistoricBtn: false,
                    usersForEmail: this.allUsers,
                    selectedFilesByUser: allUsersByFileId,
                    noText: true,
                    which: which,
                    noTextMessage: message,
                    sendMail: true,
                },
                events: {
                    close: () => {
                        this.onModalClose();
                    }
                },
            });
        },
        openModalReloadReport(which) {
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: ReloadFintocByCompany,
                props: {
                    rutCompany: this.companyRut,
                    product: which,
                },
                events: {
                    close: () => {
                    }
                },
            });
        },
        openUpdateOperationsByUserModal() {
            let allUsersByFileId = this.allUsers;
            if (allUsersByFileId == null || allUsersByFileId.length == 0) {
                alert('Error, no se encontraron usuarios para enviar un correo');
                return;
            }
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: ChangeOperationsByUsers,
                canCancel: ['escape', 'button', 'outside'],
                onCancel: () => this.onModalClose(),
                props: {
                    idCompany: this.basicData.companyId,
                    allUsers: this.allUsers,
                },
                events: {
                    close: () => {
                        getUsersByCompany(this.basicData.companyId).then(({ data }) => {
                            this.allUsers = data
                        })
                    }
                },
            });
        },
        sendObligationsToDrive(which) {
            let downloadToSheetFunc = null
            if (which == 'sii') {
                downloadToSheetFunc = downloadObligationsToSheet
            } else if (which == 'bank') {
                downloadToSheetFunc = downloadMovementsToSheet
            }

            this.loadingReloadDrive = true
            downloadToSheetFunc({
                rut_company: this.companyRut,
            }).then(({ data }) => {
                notificate(
                    `<strong>Éxito!</strong><br>
                    `+ data,
                    "is-success is-light"
                );
            }).catch((error) => {
                consoleHandlerError({ error, empty: true });
            }).finally(() => {
                this.loadingReloadDrive = false
            })
        },
        openSolicitarArchivo(fileId) {
            let allUsersByFileId = this.allFilesByUser.filter(fileUser => {
                let fileFinded = fileUser.files.filter(file => file.id == fileId)
                return fileFinded.length > 0
            })
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ['escape', 'button', 'outside'],
                onCancel: () => this.onModalClose(),
                props: {
                    fileId,
                    idCompany: this.basicData.companyId,
                    hideHistoricBtn: false,
                    selectedFilesByUser: allUsersByFileId,
                    sendMail: true,
                },
                events: {
                    close: () => {
                        this.onModalClose();
                    }
                },
            });
        },
        goToSheet() {
            let parcialUrl = 'https://docs.google.com/spreadsheets/d/' + this.basicData.general_book_id_sheet + '/view'
            window.open(parcialUrl, "_blank");
        }
    }
};
</script>
<style scoped>
.archivo_button {
    border-radius: 1px;
    border: 0;
    padding: 2px 5px;
    background-image: linear-gradient(225deg, #f5f5f5, #fafafa);
    white-space: nowrap;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.archivo_button:hover {
    transform: translateY(-2px);
    filter: drop-shadow(-1px 1px 3px #d0d0d0ff);
}

.archivo_button:active {
    transform: translateY(1px);
}

.is-secondary {
    margin-left: 10px;
}

.simple_button_extra {
    border: 1px solid #c0c0ff;
}

.sii_b_msg {
    width: 80%;
}

.sii_logo_td {
    width: 20%;
}

.sii_logo {
    height: 2em;
    width: 4em;
    padding-top: 6px;
    padding-left: 10px;
}

.volverButton {
    position: absolute;
    top: 20px;
    right: 10px;
}

.arrow {
    text-align: bottom;
    height: 22px;
    padding-top: 4px;
}
</style>